function Player2() {
  return (
    <div className="player2">
      <h1 className="play1">player2</h1>
      <div className="diedpiece">died pieces</div>
    </div>
  );
}

export default Player2;
